import { Link, useLocation, useNavigate} from 'react-router-dom';
import user from '../assets/user.png';
import styled from 'styled-components';
import toast,{ Toaster } from 'react-hot-toast';

import { PasswordValidate } from '../Helpers/validate';
import useFetch from '../hooks/fetch.hook';
import { useAuthStore } from '../store/store';
import {verifyPassword} from '../Helpers/helper'
import { Button } from '../styles/Button';
import PasswordInput from './PasswordInput';
import { useState } from 'react';

const Password = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserDetails } = useAuthStore();
  const { username } = useAuthStore(state => state.auth);

  const [{ isLoading, apiData, serverError }] = useFetch(`user/${username}`);

  // ✅ Local state instead of Formik
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Manual validation
    const errors = PasswordValidate({ password });
    if (errors.password) {
      toast.error(errors.password);
      return;
    }

    try {
      const loginPromise = verifyPassword({ username, password });

      toast.promise(loginPromise, {
        loading: 'Checking...',
        success: <b>Login Successful</b>,
        error: err => <b>{err?.message || "Password not matched"}</b>
      });

      const res = await loginPromise;
      const { token, country } = res.data;
      localStorage.setItem('token', token);

      const userDetails = {
        username: apiData.username,
        profile: apiData.profile,
        firstName: apiData.firstName,
        email: apiData.email,
        role: apiData.role,
        token,
        country
      };

      setUserDetails(userDetails);

      // if (apiData.role === "admin") {
      //   navigate('/admindashboard');
      // } else {
      //   navigate('/dashboard');
      // }
      const redirectPath = location.state?.from || 
                     (apiData.role === "admin" ? '/admindashboard' : '/dashboard');

navigate(redirectPath, { replace: true });
    } catch (err) {
      console.error("Login error:", err);
      //toast.error("Something went wrong. Please try again.");
    }
  };

  if (isLoading) return <h1>Loading...</h1>;
  if (serverError) return <h1>{serverError.message || "Error fetching user"}</h1>;


return (
  <Wrapper>
      <Toaster position='top-center' reverseOrder={false} />
      <div className='user-card'>
        <header className='user-header'>
          <h4 className='greeting'>Hello {apiData?.firstName || apiData?.username || username || 'Guest'}</h4>
          <p className='subtitle'>Explore more by connecting with us!</p>
        </header>
        <hr />
        <form onSubmit={handleSubmit} autoComplete="off">
          <img className="user-avatar" 
          src={apiData?.profile || user} 
          alt="user avatar" />
          <div className="form-fields">
          <PasswordInput
              type='password'
              className='password'
              placeholder='Password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button type='submit'>Sign-In</Button>
          </div>
        </form>
       
          <hr />
          <p className='forgot-password'>Forgot Password? 
            <span className='link'>
              <Link to='/forgot-password'>
              Recover Now
              </Link>
            </span>
            </p>
       </div>
  </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 3rem;

  .user-card {
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.bg};
    max-width: 400px;
    width: 100%;
    text-align: center;
  }

  .user-header {
    margin-bottom: 1.5rem;
  }

  .greeting {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 2rem;
  }

  .subtitle {
    font-size: 1.5rem;
    color: #0073e6;
  }

  hr {
    border: none;
    border-top: 1px solid #ccc;
    margin: 1.5rem 0;
  }

  .login-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }

  .user-avatar {
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    object-fit: cover;
  }

  .form-fields {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    width: 100%;
  }

  .password-input {
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1.2rem;
  }

  .forgot-password {
    font-size: 1.5rem;
    margin-top: 1rem;
  }

  .link {
    color: #000;
    font-weight: bold;
  }  
`;

export default Password;
